import { SyncIntegrationNames } from 'common/constants/autopilotIntegrations';

import type { Company, SyncIntegration } from 'common/api/endpoints/companies';

const isDataSourceIntegration = (integrationName: SyncIntegrationNames) =>
  integrationName !== SyncIntegrationNames.api && integrationName !== SyncIntegrationNames.imports;

export const getEnabledSyncIntegrations = (syncIntegrations: SyncIntegration[]) =>
  syncIntegrations.filter(
    ({ integrationName, disabled }) => isDataSourceIntegration(integrationName) && !disabled,
  );

export const hasEnabledSyncIntegrations = (syncIntegrations: SyncIntegration[]) =>
  syncIntegrations.some(
    ({ integrationName, disabled }) => isDataSourceIntegration(integrationName) && !disabled,
  );

export const getEnabledSyncIntegrationMap: (company: Company) => Record<string, boolean> = (
  company,
) =>
  company.installedSyncIntegrations.reduce((map, { disabled, integrationName }) => {
    return {
      ...map,
      [integrationName]: !disabled,
    };
  }, {});
